module.exports = __webpack_public_path__ + "assets/images/premium-features/shift-swap-167f42.png";